import React, { useState, useEffect } from 'react';
import { Download, X, Smartphone } from 'lucide-react';

interface PWAInstallPromptProps {
  canInstall: boolean;
  onInstall: () => void;
}

const PWAInstallPrompt: React.FC<PWAInstallPromptProps> = ({ canInstall, onInstall }) => {
  const [showPrompt, setShowPrompt] = useState<boolean>(false);

  useEffect(() => {
    if (canInstall) {
      const dismissed = sessionStorage.getItem('pwa_install_dismissed');
      if (!dismissed) {
        setShowPrompt(true);
      }
    } else {
      setShowPrompt(false);
    }
  }, [canInstall]);

  const handleInstallClick = () => {
    onInstall();
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    sessionStorage.setItem('pwa_install_dismissed', 'true');
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-24 right-6 left-6 md:left-auto md:max-w-md z-50 bg-white dark:bg-gray-900 rounded-[28px] shadow-[0_20px_50px_rgba(0,0,0,0.15)] border border-emerald-100 dark:border-emerald-950 p-6 animate-fade-in-up">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2.5 py-1 bg-emerald-100 dark:bg-emerald-950 text-emerald-700 dark:text-emerald-300 text-[10px] font-black uppercase rounded-lg tracking-widest">
              Instalação Rápida
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
          </div>
          
          <h3 className="text-base font-black text-gray-900 dark:text-white uppercase tracking-tight flex items-center gap-2">
            <Smartphone size={18} className="text-emerald-600" />
            Instalar Aplicativo
          </h3>
          
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-2 leading-relaxed">
            Clique no botão abaixo para adicionar este aplicativo diretamente à sua tela inicial.
          </p>

          <div className="mt-4 flex items-center gap-3">
            <button
              onClick={handleInstallClick}
              className="w-full md:w-auto px-5 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 text-white text-xs font-black uppercase tracking-wider rounded-xl shadow-lg shadow-emerald-200 dark:shadow-none transition-all flex items-center justify-center gap-2"
            >
              <Download size={14} />
              Instalar Agora
            </button>
          </div>
        </div>

        <button
          onClick={handleDismiss}
          className="p-1 text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg"
          aria-label="Dispensar instalação"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
